import React, { useState, useEffect, useRef } from "react";
import MiniBot from "../components/Minibot";
import ChatWidget from "../components/Chatwidget";
// import { Helmet } from "react-helmet";
import { Connection } from '../components/socketHandler/socketEventsHandler';
import { subscriber } from "../components/socketHandler/subsPubs";
import { socket } from "../../socket";
import loaderImg from "../../assets/images/ellipsis.svg";
import { btoa } from '../../cryptographic/crypto'
// import { BorderTopOutlined } from "@mui/icons-material";
import { deleteCookie, getCookie, setCookie, updateCookie } from "../utility/cookies";
import { languages } from "../utility/constants"
import FloatingWindow from "../components/FloatingWindow";
import { stopSpeaking } from "../utility/constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "../components/TalkkToDocs/Loader";
// import Sidebar from "../components/TalkkToDocs/Sidebar";
// import Header from "../../../../components/TalkktoDocsHeader";
import ChatBody from "../components/Chatwidget/ChatBody";
import Robot from "../../assets/images/robo.png";
import ChatFooter from "../components/Chatwidget/Footer";
import TypeBar from "../components/Chatwidget/Typebar";
import ProfileImg from "../../assets/images/ttd/profile.png"
import Ideas from "../../assets/images/ttd/ideas.png";
import MyFeeds from "./MyFeeds";
import ChatHistory from "./ChatHistory";
// import { active } from "d3";
import ProfileIconDefault from '../../assets/images/user.png'
import decryption from '../../decryption/DecryptData'


let callEvents = new Connection();
function Chatbot({ properties, stateObj, botInfo, loader, fMessages, voiceEnabled, botCName, widgetStyle }) {
    document.body.classList.add("bg-landing-page");
    const [closeFloat, setCloseFloat] = useState(false)
    const [agentName, setAgentName] = useState("ePa");
    const [startChat, setStartChat] = useState(false)
    const [formRequested, setFormRequested] = useState('');
    const [prefLang, setPrefLang] = useState('');
    const [isLang, setIsLang] = useState('')
    const [events, setEvents] = useState({});
    const [noFeedback, setNoFeedback] = useState(false)
    const [openFeedback, setOpenFeedback] = useState(false)
    const [filteredLang, setFilteredLang] = useState([])
    const [message, setMessage] = useState([])
    const [langSwitcher, setLangSwitcher] = useState(false)
    // console.log(botInfo,"botInfo")
    const [messageOnReload, setMessageOnReload] = useState([])
    
    // const windowGroupId = window.chat_widget_reference_no
    const windowGroupId = process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : process.env.REACT_APP_GROUPID
    const checkBotType = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Mobi" || botType === "Full" || botType === "TlkDocs") {
            return "true"
        } else {
            return "false"
        }
    }

    const [openBot, setOpenBot] = useState(checkBotType() === "true" ? true : false);
    useEffect(() => {
        if (getCookie('prefLang')) {
            let langVal = getCookie("prefLang")
            updateCookie('prefLang', langVal)
            console.log("print langVal", langVal)
        }
        else {
            updateCookie('prefLang', false)
        }

        if (getCookie('appState')) {
            let val = getCookie('appState')
            console.log("print val", val)
            updateCookie('appState', val)
        }
        else {
            updateCookie('appState', 'null')
        }

        setCookie('openBot', false, 1)
        setCookie('firstLang', null, 1)
        setCookie('hasPrechat', false, 1)
    }, [botInfo])
    useEffect(() => {
        stopSpeaking()
        var langaugeArr = languages.filter((lang) => botInfo?.data?.bot?.language.includes(lang.value));
        setFilteredLang(langaugeArr);
        console.log("print the filtered array", filteredLang)
    }, [botInfo])
    useEffect(() => {
        if (getCookie('prefLang') !== null) {
            let lang = getCookie('prefLang')
            setPrefLang(lang)
            updateCookie('prefLang', lang)
        }
    }, [])
    function generateRandomString() {
        const now = new Date();
        const timestamp = now.getTime();
        const randomNumber = Math.floor(Math.random() * 1000000);
        const randomString = `${timestamp}${randomNumber}`;
        return randomString;
    }
    useEffect(() => {
        console.log("in useEFfect", getCookie('prefLang'), "value 2", getCookie('appState'))
        if (getCookie('appState') === 'null' || getCookie('prefLang') === 'false') {
            console.log("in app state null")
            setPrefLang(null)
            setIsLang(false)
            setFormRequested(false)
            setStartChat(false)
            setOpenFeedback(false)
            setNoFeedback(false)
            deleteCookie('talkkState')
            deleteCookie('bot')
            deleteCookie('uInfo')
            setMessageOnReload([])
            setMessage([]);
            if (botInfo?.data?.bot?.language.length > 1) {
                console.log("many lang")
                updateCookie('appState', 'langNotSet')
                if (getCookie('prefLang') === 'false' || getCookie('prefLang') === 'null') {
                    // deleteCookie('prefLang');deleteCookie('appState')
                    console.log("here it comes first ekta")
                    updateCookie('prefLang', null)
                    setPrefLang(null)
                    console.log("Starts from here 11111111111111111")
                    setIsLang(false)
                    updateCookie('appState', 'langNotSet')
                }
                else {
                    let langFromCookie = getCookie('prefLang')
                    console.log("here it comes 2nd ekta")
                    updateCookie('prefLang', langFromCookie)
                    setPrefLang(langFromCookie)
                    console.log("value of prefLAng", prefLang)

                    setIsLang(true)
                    console.log("updating isLAng 1", isLang)
                    updateCookie('appState', 'langSet')


                }
            }
            else if (botInfo?.data?.bot?.language.length === 1) {
                console.log("1 lang")
                let setlang = botInfo?.data?.bot?.language[0]
                updateCookie('firstLang', setlang)
                updateCookie('prefLang', setlang)
                setPrefLang(setlang)
                setIsLang(true)
                console.log("updating isLAng 2", isLang)
                updateCookie('appState', 'langSet')
                // if(getCookie('prefLang') !== null || getCookie('prefLang') !== undefined || getCookie('prefLang') == ""){
                //   let langFromCookie = getCookie('prefLang')
                //   updateCookie('prefLang', langFromCookie)
                //   setPrefLang(langFromCookie)
                //   setIsLang(true)
                //   console.log("updating isLAng 3", isLang)
                //   updateCookie('appState', 'langSet')
                // }

                setStartChat(false)
                setOpenFeedback(false)
                setNoFeedback(false)
                socket.disconnect();
                let newSessionId = ''
                if (getCookie('sessionId')) {
                    newSessionId = getCookie('sessionId')
                } else {
                    newSessionId = generateRandomString()
                    updateCookie("sessionId", newSessionId)
                }
                const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
                const ttdsSocket1 ={
                    type : "user",
                    page: 'chat',
                    locale: setlang,
                    group: windowGroupId,
                    session_id : window.sessionId,
                    platform : "talkkmesanger",
                    EIO: "3",
                    transport : "websocket"
                }
                const ttdsSocket2 ={
                    type : "user",
                    page: 'chat',
                    locale: setlang,
                    group: windowGroupId,
                    session_id : newSessionId,
                    EIO: "3",
                    transport : "websocket"
                }
                if(botType === "TlkDocs"){
                    socket.io.opts.query = {q: btoa(ttdsSocket1)};
                }else{
                    socket.io.opts.query = {q: btoa(ttdsSocket2)};
                }
                socket.connect();
            }

        }
        else if (getCookie('appState') === 'langNotSet') {
            console.log("in app state langNotSet")
            // if(getCookie('hasPrechat') === true){
            //   setFormRequested(true)
            // }
            // else{
            //   setFormRequested(false)
            //   console.log("error 1")
            // }
            setFormRequested(false)
            setStartChat(false)
            setIsLang(false)
            setOpenFeedback(false)
            setNoFeedback(false)
        }
        else if (getCookie('appState') === 'langSet') {
            console.log("in app state langSet")
            console.log("value of prechat vokkie", getCookie('hasPrechat'))
            if (getCookie('hasPrechat') === true) {
                setFormRequested(true)
            }
            else {
                setFormRequested(false)
                console.log("error 2")
            }

            setStartChat(false)
            setIsLang(true)
            setOpenFeedback(false)
            setNoFeedback(false)
        }
        else if (getCookie('appState') === 'hasPrechat') {
            console.log("in app state hasPReChat")
            setFormRequested(true)
            setStartChat(false)
            setIsLang(true)
            setOpenFeedback(false)
            setNoFeedback(false)
        }
        else if (getCookie('appState') === 'chatTrue') {
            console.log("in app state chatTrue")
            setStartChat(true)
            setFormRequested(false)
            console.log("error 3")
            setIsLang(true)
            setOpenFeedback(false)
            setNoFeedback(false)
        }

        else if (getCookie('appState') === 'closeChat' || getCookie('appState') === 'hasFeedback' || getCookie('appState') === 'hasNoFeedback') {

            console.log("in app state hasFeedback or no Feedback")
            setStartChat(false)
            setFormRequested(false)
            console.log("error 4")
            setIsLang(true)
            setOpenFeedback(false)
            setNoFeedback(false)

        }

        // else if(){
        //   setStartChat(false)
        //   setFormRequested(false)
        //   console.log("error 5")
        //   setIsLang(true)
        //   setOpenFeedback(false)
        //   setNoFeedback(false)
        // }
        else {
            console.log("in app state else")
            setMessageOnReload([])
            setMessage([]);
            setPrefLang(null)
            setIsLang(false)
            setFormRequested(false)
            console.log("error 6")
            setStartChat(false)
            setOpenFeedback(false)
            setNoFeedback(false)
            deleteCookie('talkkState')
            deleteCookie('bot')
            deleteCookie('uInfo')
        }

    }, [openBot, closeFloat, botInfo])

    function generateRandomString() {
        const now = new Date();
        const timestamp = now.getTime();
        const randomNumber = Math.floor(Math.random() * 1000000);
        const randomString = `${timestamp}${randomNumber}`;
        return randomString;
    }
    const closeChatHandler = () => {
        if (botInfo?.data?.bot?.language.length > 1 && isLang === false) {
            setLangSwitcher(true);
            setCloseFloat(true);
        } else {
            // if(getCookie("appState") === "hasFeedback"){
            //     deleteCookie("sessionId")
            //     setCookie("appState", "hasPrechat")
            // }
            setOpenBot(true);
            setCloseFloat(true);
            setOpenFeedback(false)
            setNoFeedback(false)
        }
        socket.emit(btoa(["user-option", {}]));
    }

    useEffect(() => {
        callEvents.eventsCall()
        let sub = subscriber.subscribe((returnedEvents) => {
            // console.log("ooooooooooooo",returnedEvents)
            if (returnedEvents) {
                if (Object.keys(returnedEvents).length > 0) {
                    setEvents(returnedEvents)

                    if (events["user-message"]) {
                    }
                    if (events["agent-message"]) {
                        let agentName = events["agent-message"][1].userId.displayName;
                        setAgentName(agentName)

                    }
                    if (events["user-send"]) {
                    }
                    if (events["agent-tyeping"]) {
                    }
                    if (events["postForm"]) {
                    }
                    if (events["close-chat"]) {
                    }

                }
            }
        }
        )
    }, [])

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true
    };
    const [prefTextChange, setPrefTextChange] = useState([])
    useEffect(() => {
        if (botInfo?.data?.mobileAppConfig?.preferredLanguage) {
            let val = [];
            for (let [key, value] of Object.entries(botInfo?.data?.mobileAppConfig?.preferredLanguage)) {
                val.push(value)
            }
            setPrefTextChange(val)
        }
        else {
            let val = [];
            val.push("en")
            setPrefTextChange(val)
        }
    }, [botInfo])

    useEffect(() => {
        const setDynamicHeight = () => {
          const deviceHeight = window.innerHeight;
          const root = document.documentElement;
          root?.style.setProperty("--mobile-height", `${deviceHeight}px`);
          const root2 = getComputedStyle(document.body)
        };
    
        setDynamicHeight();
    
        window.addEventListener('resize', setDynamicHeight);
        window.addEventListener('orientationchange', setDynamicHeight);
    
        return () => {
            window.removeEventListener('resize', setDynamicHeight);
            window.removeEventListener('orientationchange', setDynamicHeight);
        };
      }, []);

    useEffect(()=>{
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Mobi" || botType === "Full" || botType === "TlkDocs") {
            socket.emit(btoa(["user-option", {}]));
        }
    },[])
    return (
        <div className={`talkk-web-chatbot-main-wrap ${widgetStyle === "style3" ? "theme-mumbai-port" : ""}`}>
            {
                checkBotType() === "true" ?
                    <>
                        {loader && <Loader />}
                        {
                            botInfo?.data?.appInfo &&
                            <ChatWidget openFeedback={openFeedback} setMessage={setMessage} message={message} setMessageOnReload={setMessageOnReload} messageOnReload={messageOnReload} setOpenFeedback={setOpenFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} closeChatHandler={closeChatHandler} setCloseFloat={setCloseFloat} filteredLang={filteredLang} openBot={openBot} setOpenBot={setOpenBot} agentName={agentName} socket={socket} startChat={startChat} setStartChat={setStartChat} formRequested={formRequested} setFormRequested={setFormRequested}
                                events={events} prefLang={prefLang} setPrefLang={setPrefLang} isLang={isLang} setIsLang={setIsLang} botInfo={botInfo} voiceEnabled={voiceEnabled} botCName={botCName} widgetStyle={widgetStyle} />
                        }
                    </>
                    :
                    <>
                        {
                            botInfo?.data?.appInfo &&
                            <div className="mini-bot-main-wrap">
                                <FloatingWindow appInfo={botInfo?.data?.appInfo} fMessages={fMessages} closeFloat={closeFloat} setCloseFloat={setCloseFloat} setOpenBot={setOpenBot} setLangSwitcher={setLangSwitcher} botInfo={botInfo} isLang={isLang} langSwitcher={langSwitcher} openBot={openBot} />
                                <MiniBot openBot={openBot} closeChatHandler={closeChatHandler} setStartChat={setStartChat} setOpenBot={setOpenBot} socket={socket} events={events} botInfo={botInfo} setCloseFloat={setCloseFloat} prefLang={prefLang} setLangSwitcher={setLangSwitcher} isLang={isLang} langSwitcher={langSwitcher} />
                            </div>
                        }
                        {
                            botInfo?.data?.bot?.language.length > 1 && isLang === false && checkBotType() === "false" && langSwitcher ?
                                <div className="floating-card language-floating-card">
                                    <Slider {...settings}>
                                        {
                                            prefTextChange?.map(lang => {
                                                return <p key={lang} className='change-lang-para'>{lang}</p>
                                            })
                                        }
                                    </Slider>
                                    <div className="change-langage-block">
                                        {
                                            filteredLang?.map((lang, i) => {
                                                return (
                                                    <div className="language-block" key={i} onClick={() => {
                                                        setPrefLang(lang.value);
                                                        updateCookie('prefLang', lang.value);
                                                        setIsLang(true);
                                                        console.log("updating isLAng 4", isLang)
                                                        updateCookie('firstLang', lang.value)
                                                        updateCookie('appState', 'langSet')
                                                        socket.disconnect()
                                                        let newSessionId = ''
                                                        if (getCookie('sessionId')) {
                                                            newSessionId = getCookie('sessionId')
                                                        } else {
                                                            newSessionId = generateRandomString()
                                                            updateCookie("sessionId", newSessionId)
                                                        }
                                                        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
                                                        if(botType === "TlkDocs"){
                                                            socket.io.opts.query = 'type=user&page=chat&locale=' + lang.value + '&group=' + windowGroupId +'&session_id='+ window.sessionId +'&platform=talkkmesanger'+'&EIO=3&transport=websocket';
                                                        }else{
                                                            socket.io.opts.query = 'type=user&page=chat&locale=' + lang.value + '&group=' + windowGroupId +'&session_id='+ newSessionId + '&EIO=3&transport=websocket';
                                                        }
                                                        socket.connect()
                                                        setOpenBot(true)
                                                        setLangSwitcher(false)
                                                    }}>
                                                        {lang?.label === "Kreol " ? "Kreol (Trial)" : lang?.label}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                :
                                ""
                        }
                        <ChatWidget openFeedback={openFeedback} setMessage={setMessage} message={message} setMessageOnReload={setMessageOnReload} messageOnReload={messageOnReload} setOpenFeedback={setOpenFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} closeChatHandler={closeChatHandler} setCloseFloat={setCloseFloat} filteredLang={filteredLang} openBot={openBot} setOpenBot={setOpenBot} agentName={agentName} socket={socket} startChat={startChat} setStartChat={setStartChat} formRequested={formRequested} setFormRequested={setFormRequested}
                                events={events} prefLang={prefLang} setPrefLang={setPrefLang} isLang={isLang} setIsLang={setIsLang} botInfo={botInfo} voiceEnabled={voiceEnabled} botCName={botCName} widgetStyle={widgetStyle} />
                    </>
            }
        </ div>
    );
}

export default Chatbot;
